var Toolbar = {
	insertLinkDisabled: "Link - Select text",
	additionalControls: "Additional controls",
	selectedFormatting: "Formatting options, {format} selected",
	styles: {
		paragraph: "Paragraph",
		heading: "Heading {headingLevel}",
		blockquote: "Blockquote"
	},
	showHTML: "Show HTML",
	hideHTML: "Show editor",
	formatting: "Formatting",
	bold: "Bold",
	italic: "Italic",
	underline: "Underline",
	color: "Color",
	insertTable: "Insert table",
	orderedList: "Numbered list",
	unorderedList: "Bulleted list",
	outdent: "Outdent",
	indent: "Indent",
	alignment: "Alignment",
	clearFormatting: "Clear formatting",
	tables: {
		insertRowBelow: "Insert row below",
		insertRowAbove: "Insert row above",
		insertColBefore: "Insert column before",
		insertColAfter: "Insert column after",
		deleteRow: "Delete row",
		deleteCol: "Delete column",
		deleteTable: "Delete table"
	}
};
var _en = {
	Toolbar: Toolbar
};

export { Toolbar, _en as default };
